import { render, staticRenderFns } from "./MultiPageForm.vue?vue&type=template&id=0db19c83"
import script from "./MultiPageForm.vue?vue&type=script&lang=js"
export * from "./MultiPageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports